// ** Third Party Components
/* eslint-disable */
import PropTypes from "prop-types";
import classnames from "classnames";

// ** Reactstrap Imports
import { Card, CardBody } from "reactstrap";
import '@src/@core/scss/base/pages/app-invoice.scss';

const StatsHorizontal = ({
  icon,
  color,
  stats,
  renderStats,
  statTitle,
  className,
  statsMargin,
}) => {
  return (
        <div className="d-flex justify-content-between align-items-center">
          
          <div className="stats">
          <p className="card-text">
                {statTitle}</p>
            {renderStats ? (
              renderStats
            ) : (
              <h4
                className={classnames("fw-bolder", {
                  "mb-0": !statsMargin,
                  [statsMargin]: statsMargin,
                })}>
              {stats}
              </h4>
            )}

           
          </div>
         
        </div>
  );
};

export default StatsHorizontal;

// ** PropTypes
StatsHorizontal.propTypes = {
  stats: PropTypes.string,
  renderStats: PropTypes.any,
  className: PropTypes.string,
  icon: PropTypes.element.isRequired,
  color: PropTypes.string.isRequired,
  statTitle: PropTypes.string.isRequired,
  statsMargin: PropTypes.oneOf([
    "mb-0",
    "mb-25",
    "mb-50",
    "mb-75",
    "mb-1",
    "mb-2",
    "mb-3",
    "mb-4",
    "mb-5",
  ]),
};
